module.exports = __webpack_public_path__ + "img/zSMTDoELzjDs9XqHfGX6ODghaflO6N6TT0zBv7a8.fa599ecb.png";